var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.avatars),function(avatar){return (!_vm.disabled || avatar === _vm.value)?_c('agent-profile-picture',{key:avatar,staticClass:"cursor-pointer avatar",class:{selected: avatar === _vm.value},attrs:{"avatar":avatar},nativeOn:{"click":function($event){return _vm.setAvatar(avatar)}}}):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }